import React from 'react';
import { Data, DotLottieReact } from '@lottiefiles/dotlottie-react';

export interface AnimationViewProps {
  autoPlay?: boolean;
  loop?: boolean;
  source: Data;
  style?: React.CSSProperties;
}

export const AnimationView: React.FC<AnimationViewProps> = ({
  autoPlay = true,
  loop = true,
  source,
  style,
}) => (
  <DotLottieReact
    autoplay={autoPlay}
    data={source}
    loop={loop}
    renderConfig={{
      autoResize: true,
      devicePixelRatio: window.devicePixelRatio * 2,
    }}
    style={style}
  />
);
